// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"translationProvider_loaderWrapper__C-T4Y"};